import { createSlice } from "@reduxjs/toolkit";

const _initialState = {
  selectedDocsIds: [],
  tableFilters: {
    macroCategory: "",
    category: "",
    minAmount: "",
    maxAmount: "",
  },
};

const documentManagementSlice = createSlice({
  name: "docManagementSlice",
  initialState: _initialState,
  reducers: {
    setTableFilters: (state, action) => {
      state.tableFilters = action.payload;
    },
    setSelectedDocsIds: (state, action) => {
      state.selectedDocsIds = action.payload;
    },
  },
});

export default documentManagementSlice;
export const { name, reducer, actions } = documentManagementSlice;
